import React, { Component } from 'react';
import './Home.css';
import { Container, Row, Col, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import CheeseburgerMenu from 'cheeseburger-menu';
import HamburgerMenu from 'react-hamburger-menu';
import Header from './Header';
import Profile from './Profile';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: '1',
            menuOpen: false
        };
    }

    openMenu() {
        this.setState({ menuOpen: true })
    }

    closeMenu() {
        this.setState({ menuOpen: false })
    }

    handleClick() {
        this.setState({
            open: !this.state.open
        });                    
    }

    toggle(tab)
    {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {
        Container.propTypes = {
            fluid:  PropTypes.bool
        }

        return (
            <div className="fullHeight">
                <Container fluid className="removeMargin removePadding headerContainer fullHeight">
                    <Header toggle={this.toggle.bind(this)} state={this.state}/>
                    <Row className="bodyRow">
                        <Col>
                        <TabContent className="fullHeight" activeTab={this.state.activeTab}>
                            <TabPane className="fullHeight iFrameContainer" tabId="1">
                                <div className="pageBackground fullHeight">
                                    <div className="homePage">
                                        <div className="home1">Analytical skills</div>
                                        <div className="home2">Leadership</div>
                                        <div className="home3">Versatility</div>
                                        <div className="home4">Teamwork</div>
                                    </div>
                                    <br/>
                                    <br/>
                                    <div className="BillGates">
                                        "Information technology and business are becoming inextricably interwoven.
                                        I don’t think anybody can talk meaningfully about one without talking about the other." - Bill Gates
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tabId="2">
                                <Profile/>
                            </TabPane>

                            <TabPane tabId="3">
                                <div className="pageBackground fullHeight">
                                    <h1>About Bizwell Technologies</h1>
                                    <div className="aboutUs">
                                        <b>BizWell Technologies</b><sup>SM</sup> formed in 2010 and based in San Ramon, California is a sole proprietorship concern with proprietor as Pawan Rijhwani.
                                        Primarily we specialize in building websites and software application with simple, quick, and elegant outcomes. 
                                        Our expertise also cover any technology issues with computers and laptops. 
                                        Please navigate our website to learn more about us and the services we provide. 
                                        We strive to provide our customers with superior, affordable and reliable technical support. 
                                        BizWell	Technologies<sup>SM</sup> is committed to meet all your needs, and we look forward to serving you.
                                        <br/>
                                        <br/>
                                        <b>Mission:</b> Our mission is to provide interactive and quick services for any computer related problems.
                                    </div>
                                    </div>
                            </TabPane>
                            <TabPane tabId="4">
                                <div className="pageBackground fullHeight">
                                    <h1>Contact Information</h1>
                                    <div className="contactUsBorder">
                                        <h1>Bizwell Technologies<sup className="contactUsSM">SM</sup></h1>
                                        <p>Focused on simple and best designs for your business and low prices for our customers </p>
                                        <div className="contactUsDetails">
                                            <p><b><u>Contact Person</u>:</b> Pawan Rijhwani</p>
                                            <p><b><u>Location</u>:</b> San Ramon, California</p>
                                            <p><b><u>Phone Number</u>:</b> 510-828-2653</p>
                                            <p><b><u>Email Id</u>:</b> bizwelltechnologies@gmail.com</p>
                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                        </TabContent>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}
export default Home;
